import { CountryEntity } from '../entities/country-entity';

export default class State {
  loaded = false;

  items: Array<CountryEntity> = [];
}
